/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { never } from '../../../util.type';
import StretchEnum from '../../stretch/stretch-enum';

/**
 * Komunikátor roztažení média pro Ki-Wi Server.
 */
class CommunicatorStretch {
  // TODO: Onakvé, že očekávané prázdné hodnoty není možné odlišit od nesmyslů,
  // tj. že default by měl spíše vyhazovat výjimku než vracet undefined.
  /**
   * Zpracuje roztažení média.
   * @param {'' | 'fill' | 'uniform' | 'uniformToFill' | null | undefined} value Roztažení ve formátu, který vrací server.
   * @returns {StretchEnum | undefined} Roztažení média.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 'fill':
        result = StretchEnum.FILL;
        break;
      case 'uniform':
        result = StretchEnum.CONTAIN;
        break;
      case 'uniformToFill':
        result = StretchEnum.COVER;
        break;
      case '':
      case null:
      case undefined:
        result = undefined;
        break;
      default:
        never(value);
        result = undefined;
    }
    return result;
  }
}

export default CommunicatorStretch;
